import React, {useEffect} from 'react';
import Breadcrumb from "./Breadcrumb";
import {staggeredFadeInDivEffect} from "./staggeredFadeInDivEffect";
import {BackToTop} from "./BackToTop";
import '../style/css/components/Contato.css';

function Contato(){

	useEffect(()=>{
		BackToTop();
		staggeredFadeInDivEffect(50)
	})

	return (
		<div className='fade-enter'>
			<Breadcrumb page='Contato'/>

			<div className="row">
				<div className="col">
					<h1>Vamos trabalhar juntos?</h1>
				</div>
			</div>

			<div className="row">
				<div className="col-12 col-md-4">
					<div className="card card_Contato">
						<h5>WhatsApp</h5>
						<p>(21) 96512-7584</p>
						<a
							href="https://web.whatsapp.com/send?phone=5521965127584"
							target='_blank'
							className='btn btn-whatsapp'
							rel="noreferrer"
						>
							Enviar mensagem
						</a>
					</div>
				</div>
				<div className="col-12 col-md-4">
					<div className="card card_Contato">
						<h5>Email</h5>
						<p>lucpmatos@gmail.com</p>
						<a
							href="mailto:lucpmatos@gmail.com"
							target='_blank'
							className='btn btn-email'
							rel='noreferrer'
						>
							Enviar e-mail
						</a>
					</div>
				</div>
				<div className="col-12 col-md-4">
					<div className="card card_Contato">
						<h5>LinkedIn</h5>
						<p>Lucas Pedro</p>
						<a
							href="https://www.linkedin.com/in/lucas-pedro-84b574a0/"
							target='_blank'
							className='btn btn-linkedin'
							rel="noreferrer"
						>
							Acessar perfil
						</a>
					</div>
				</div>
			</div>

		</div>
	);
}

export default Contato;
